var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup23(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1BA6A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.25H15C12.38 12.25 10.25 14.38 10.25 17V23C10.25 25.62 12.38 27.75 15 27.75H25C27.62 27.75 29.75 25.62 29.75 23V17C29.75 14.38 27.62 12.25 25 12.25ZM28.25 23C28.25 24.79 26.79 26.25 25 26.25H15C13.21 26.25 11.75 24.79 11.75 23V17C11.75 15.21 13.21 13.75 15 13.75H25C26.79 13.75 28.25 15.21 28.25 17V23Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5791 16.3798L20.6891 19.6399C20.2691 19.9199 19.7191 19.9199 19.2991 19.6399L14.4091 16.3798C14.0691 16.1498 13.5991 16.2398 13.3691 16.5898C13.1391 16.9398 13.2291 17.3998 13.5791 17.6298L18.4691 20.8899C18.9291 21.1999 19.4591 21.3499 19.9991 21.3499C20.5391 21.3499 21.0591 21.1999 21.5291 20.8899L26.4191 17.6298C26.7591 17.3998 26.8591 16.9298 26.6291 16.5898C26.3991 16.2498 25.9291 16.1498 25.5891 16.3798H25.5791Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup23);
export default __webpack_public_path__ + "static/media/Group 23.735578bed65c89431bc01a8a13651ab8.svg";
export { ForwardRef as ReactComponent };